import { useEffect } from "react";
import { useSignalR } from "./SignalRProvider";
import { logger } from "../../utils/logger";

const HUB_URL = "/hub";

export const useHotelGroupManagement = (hotelId?: string): void => {
  const { joinGroup, leaveGroup, onReconnected } = useSignalR();

  useEffect(() => {
    if (!hotelId) return;

    logger.log(
      `HotelHubProvider: Attempting to join hotel group: ${hotelId}`,
    );
    joinGroup(HUB_URL, hotelId).catch((error) => {
      logger.error("Failed to join hotel group:", error);
    });

    return () => {
      leaveGroup(HUB_URL, hotelId).catch((error) => {
        logger.error("Failed to leave hotel group:", error);
      });
    };
  }, [hotelId, joinGroup, leaveGroup]);

  useEffect(() => {
    if (!hotelId) return;

    const unsubscribe = onReconnected(HUB_URL, () => {
      logger.log(
        `HotelHubProvider: Rejoining hotel group ${hotelId} after reconnect`,
      );
      joinGroup(HUB_URL, hotelId).catch((error) => {
        logger.error(
          "Failed to rejoin hotel group after reconnect:",
          error,
        );
      });
    });

    return unsubscribe;
  }, [hotelId, joinGroup, onReconnected]);
};
